<p class="mt-3 default-font-size">
    <span translate="{{greetingTranslationKey}}" [translateParams]="translationParameters">
    </span>
</p>